import moment from 'moment-timezone';

import { fromAnyDateToIso } from 'utils/converters/time/from.util';
import zonedMoment from 'utils/date/zonedMoment.util';
import logger from 'utils/logger.util';
import { isTimeBefore } from 'utils/predicates/time/compare.util';

const L = logger('timeInRangeSimple'); // eslint-disable-line no-unused-vars

const timeInRangeSimple = (options) => {
  try {
    const { length, slot, current, tz } = options ?? {};

    const currentIso = fromAnyDateToIso(zonedMoment(tz, current).set({ second: 0, millisecond: 0 }));
    const slotIso = fromAnyDateToIso(zonedMoment(tz, slot).set({ second: 0, millisecond: 0 }));

    if (isTimeBefore(currentIso, slotIso)) return false;

    const endIso = fromAnyDateToIso(moment(slotIso).add(moment.duration(length, 'minutes')));

    return isTimeBefore(currentIso, endIso);
  } catch (e) {
    L.warn('()', 'options:', options, 'error:', e);
  }
};

export default timeInRangeSimple;
